import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; // 🟢 KHÔI PHỤC THEME GỐC BẢO VỆ NAVBAR
import { 
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, 
    TextField, Pagination, Typography, Card, Stack, Chip, TableContainer, CircularProgress,
    Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, FormControl, InputLabel
} from "@mui/material";
import { Search as SearchIcon, DeleteForever as DeleteForeverIcon, DeleteOutline as DeleteIcon } from "@mui/icons-material";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import { t } from "i18next";

// ==========================================
// THEME GIAO DIỆN MỚI CHO BẢNG BÊN TRONG
// ==========================================
const minimalistTheme = createTheme({
    palette: {
        background: { default: "#F9F9F9", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#A1A5B7" }, 
        primary: { main: "#2563EB", light: "#EFF6FF" }, 
        success: { main: "#16A34A", light: "#DCFCE7" }, 
        danger: { main: "#EF4444", light: "#FEE2E2" },  
        warning: { main: "#F59E0B", light: "#FEF3C7" },
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: { styleOverrides: { root: { borderRadius: "12px", border: "1px solid #EFF2F5", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.02)" } } },
        MuiTable: { styleOverrides: { root: { border: "none !important", borderCollapse: "collapse !important" } } },
        MuiTableCell: {
            styleOverrides: {
                root: { 
                    borderBottom: "1px solid #EFF2F5 !important", padding: "16px 12px", color: "#3F4254", 
                    fontSize: "0.85rem", fontFamily: "'Plus Jakarta Sans', sans-serif !important", backgroundColor: "transparent !important"
                }
            }
        },
        MuiButton: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif" } } }
    }
});

axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("user");
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    return config;
}, (error) => Promise.reject(error));

function Request() {
    function formatDate(m) {
        if (!m) return "";
        const d = new Date(m);
        return `${d.getUTCFullYear()}/${("0" + (d.getMonth() + 1)).slice(-2)}/${("0" + d.getDate()).slice(-2)}  ${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}`;
    }

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [note, setNote] = useState("");
    const [profile] = useState(JSON.parse(localStorage.getItem("profile")));
    
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searched, setSearched] = useState("");
    const limit = 10;
    const typingTimeoutRef = useRef(null);

    // ==========================================
    // STATES CHO TÍNH NĂNG XÓA
    // ==========================================
    const [selectedIds, setSelectedIds] = useState([]);
    const [openCleanModal, setOpenCleanModal] = useState(false);
    const [cleanRangeType, setCleanRangeType] = useState('month');
    const [cleanStartDate, setCleanStartDate] = useState('');
    const [cleanEndDate, setCleanEndDate] = useState('');

    const fetchWithdrawals = () => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL}/payment/rut?page=${page}&limit=${limit}&search=${searched}`)
            .then((res) => {
                setData(res.data.data);
                if (res.data.totalPages) setTotalPages(res.data.totalPages);
                setLoading(false);
                setSelectedIds([]); // Reset tick chọn khi load data
            })
            .catch((err) => { console.log(err); setLoading(false); });
    };

    useEffect(() => {
        fetchWithdrawals();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, searched]);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
        typingTimeoutRef.current = setTimeout(() => { setSearched(value); setPage(1); }, 500);
    };

    const handleChangePage = (e, newPage) => setPage(newPage);

    // ==========================================
    // XỬ LÝ TICK CHỌN & XÓA LỆNH CHỈ ĐỊNH
    // ==========================================
    const handleSelectAll = (e) => {
        if (e.target.checked && data) {
            setSelectedIds(data.map(item => item._id));
        } else {
            setSelectedIds([]);
        }
    };

    const handleSelectOne = (id) => {
        setSelectedIds(prev => {
            if (prev.includes(id)) {
                return prev.filter(selectedId => selectedId !== id);
            } else {
                return [...prev, id];
            }
        });
    };

    const handleDeleteSelected = () => {
        swal({
            title: "Xóa lệnh rút?",
            text: `Bạn chuẩn bị xóa vĩnh viễn ${selectedIds.length} lệnh giao dịch. Hành động này không thể khôi phục!`,
            icon: "warning",
            buttons: ["Hủy", "Xác nhận Xóa"],
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                setLoading(true);
                try {
                    const res = await axios.post(`${process.env.REACT_APP_API_URL}/payment/deletepayment`, {
                        ids: selectedIds
                    });
                    swal("Thành công!", res.data.message || "Đã xóa lệnh thành công.", "success");
                    setSelectedIds([]);
                    fetchWithdrawals(); 
                } catch (error) {
                    swal("Lỗi", "Không thể xóa lệnh giao dịch!", "error");
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    // ==========================================
    // XỬ LÝ DỌN DỮ LIỆU THEO THỜI GIAN
    // ==========================================
    const handleCleanDataRange = async () => {
        if (cleanRangeType === 'custom' && (!cleanStartDate || !cleanEndDate)) {
            return swal("Cảnh báo", "Vui lòng chọn đầy đủ Ngày bắt đầu và Ngày kết thúc!", "warning");
        }

        swal({
            title: "Cảnh báo nguy hiểm!",
            text: "Hành động này sẽ XÓA VĨNH VIỄN các lệnh rút trong khoảng thời gian đã chọn. Bạn chắc chắn muốn tiếp tục?",
            icon: "warning",
            buttons: ["Hủy bỏ", "Xóa Dữ Liệu"],
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                setLoading(true);
                try {
                    const res = await axios.post(`${process.env.REACT_APP_API_URL}/payment/deletepaymentsbyrange`, {
                        rangeType: cleanRangeType,
                        startDate: cleanStartDate,
                        endDate: cleanEndDate
                    });
                    swal("Thành công!", res.data.message || "Đã dọn dẹp dữ liệu.", "success");
                    setOpenCleanModal(false);
                    fetchWithdrawals();
                } catch (error) {
                    swal("Lỗi", "Có lỗi xảy ra khi dọn dẹp dữ liệu!", "error");
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    const tableHeadSx = {
        color: "#A1A5B7 !important", fontWeight: "700 !important", fontSize: "0.75rem !important", 
        backgroundColor: "#FFFFFF !important", borderBottom: "2px solid #EFF2F5 !important",
        borderTop: "none !important", textTransform: "uppercase !important", whiteSpace: "nowrap", py: 2
    };

    const inputStyle = {
        padding: "8px 12px", border: "1px solid #E4E6EF", borderRadius: "6px", outline: "none", 
        fontSize: "0.85rem", fontFamily: "'Plus Jakarta Sans', sans-serif", color: "#181C32", width: "100%", boxSizing: "border-box",
        backgroundColor: "#F9F9F9", transition: "border-color 0.2s"
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <ThemeProvider theme={minimalistTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        .safe-request-zone * { box-sizing: border-box; font-family: 'Plus Jakarta Sans', sans-serif !important; text-align: left !important; }
                        .custom-input-metronic:focus { border-color: #2563EB !important; background-color: #FFFFFF !important; box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); }
                    `}</style>

                    <Box className="safe-request-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: '#F9F9F9', minHeight: 'calc(100vh - 70px)', position: 'relative' }}>
                        
                        {loading && (
                            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' }}>
                                <CircularProgress size={50} sx={{ color: '#2563EB' }} />
                            </Box>
                        )}

                        <Container maxWidth="xl" sx={{ px: { xs: 2, md: 3 } }}>
                            <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
                                <Box>
                                    <Typography variant="h5" fontWeight="800" color="#181C32" gutterBottom>{t("withdraw")}</Typography>
                                    <Typography variant="body2" fontWeight="500" color="#7E8299">Quản lý và xét duyệt các lệnh rút tiền từ người dùng</Typography>
                                </Box>

                                <Stack direction="row" spacing={1.5} alignItems="center">
                                    {/* NÚT XÓA ĐA LUỒNG */}
                                    {selectedIds.length > 0 && (
                                        <Button 
                                            variant="contained" 
                                            startIcon={<DeleteForeverIcon />}
                                            onClick={handleDeleteSelected}
                                            sx={{ 
                                                textTransform: 'none', fontWeight: 800, borderRadius: '6px', 
                                                backgroundColor: '#DC2626', color: '#FFF', boxShadow: 'none',
                                                animation: 'pulse 2s infinite',
                                                '@keyframes pulse': {
                                                    '0%': { boxShadow: '0 0 0 0 rgba(220, 38, 38, 0.4)' },
                                                    '70%': { boxShadow: '0 0 0 10px rgba(220, 38, 38, 0)' },
                                                    '100%': { boxShadow: '0 0 0 0 rgba(220, 38, 38, 0)' }
                                                },
                                                '&:hover': { backgroundColor: '#B91C1C' }
                                            }}
                                        >
                                            Xóa {selectedIds.length} lệnh
                                        </Button>
                                    )}

                                    {/* NÚT DỌN DỮ LIỆU CHUNG */}
                                    <Button 
                                        variant="outlined" 
                                        startIcon={<DeleteIcon />}
                                        onClick={() => setOpenCleanModal(true)}
                                        sx={{ 
                                            textTransform: 'none', fontWeight: 700, borderRadius: '6px', 
                                            borderColor: '#E4E6EF', color: '#EF4444', backgroundColor: '#FFF',
                                            '&:hover': { backgroundColor: '#FEF2F2', borderColor: '#FCA5A5' }
                                        }}
                                    >
                                        Dọn Dữ Liệu
                                    </Button>
                                </Stack>
                            </Box>

                            <Card sx={{ borderRadius: "12px", border: "1px solid #EFF2F5", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.02)" }}>
                                <Box sx={{ p: 2.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, borderBottom: '1px solid #EFF2F5' }}>
                                    <Typography variant="subtitle1" fontWeight="800" color="#181C32">Danh sách lệnh rút</Typography>
                                    <TextField 
                                        onChange={handleSearchChange} placeholder={t("search") + "..."} size="small"
                                        InputProps={{
                                            startAdornment: <SearchIcon sx={{ color: '#A1A5B7', mr: 1, fontSize: '1.2rem' }} />,
                                            sx: { borderRadius: '6px', backgroundColor: '#F9F9F9', '& fieldset': { borderColor: '#E4E6EF' }, minWidth: '250px', fontSize: '0.85rem', fontWeight: '500' }
                                        }}
                                    />
                                </Box>

                                <TableContainer sx={{ overflowX: 'auto' }}>
                                    <Table sx={{ minWidth: 1460 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{...tableHeadSx, pl: 3, width: '3%'}}>
                                                    <input 
                                                        type="checkbox" 
                                                        style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: '#2563EB' }}
                                                        checked={data && data.length > 0 && selectedIds.length === data.length}
                                                        onChange={handleSelectAll}
                                                    />
                                                </TableCell>
                                                <TableCell sx={tableHeadSx}>TÀI KHOẢN</TableCell>
                                                <TableCell sx={tableHeadSx}>{t('payment')} & CHI TIẾT</TableCell>
                                                <TableCell sx={tableHeadSx}>{t("money")}</TableCell>
                                                <TableCell sx={tableHeadSx}>{t("balance")}</TableCell>
                                                <TableCell sx={tableHeadSx}>{t("status")}</TableCell>
                                                <TableCell sx={tableHeadSx}>THỜI GIAN</TableCell>
                                                <TableCell align="right" sx={{...tableHeadSx, pr: 3, minWidth: "280px"}}>XỬ LÝ</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        
                                        {data != null && data.length > 0 ? (
                                            <TableBody>
                                                {data.map((item) => (
                                                    <TableRow 
                                                        key={item._id} 
                                                        hover 
                                                        sx={{ 
                                                            verticalAlign: 'top', 
                                                            backgroundColor: selectedIds.includes(item._id) ? '#EFF6FF' : 'transparent',
                                                            '& td': { borderBottom: '1px solid #EFF2F5' } 
                                                        }}
                                                    >
                                                        <TableCell sx={{ pl: 3, py: 2 }}>
                                                            <input 
                                                                type="checkbox" 
                                                                style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: '#2563EB' }}
                                                                checked={selectedIds.includes(item._id)}
                                                                onChange={() => handleSelectOne(item._id)}
                                                            />
                                                        </TableCell>
                                                        
                                                        <TableCell sx={{ py: 2 }}>
                                                            <Typography variant="body2" fontWeight="800" color="#2563EB" mb={0.5}>{item?.user?.username}</Typography>
                                                            <Typography variant="caption" fontWeight="600" color="text.secondary">ID: {item?.user?.iduser}</Typography>
                                                        </TableCell>
                                                        
                                                        <TableCell sx={{ py: 2 }}>
                                                            <Typography variant="body2" fontWeight="700" color="#181C32" mb={0.5}>{item?.detail}</Typography>
                                                        </TableCell>
                                                        
                                                        <TableCell sx={{ py: 2, fontWeight: "800", color: "#EF4444", whiteSpace: "nowrap" }}>
                                                            {Number(item?.money).toLocaleString("vi-VN")} đ
                                                        </TableCell>
                                                        
                                                        <TableCell sx={{ py: 2, fontWeight: "700", color: "#4B5675" }}>
                                                            {item?.user?.money?.toLocaleString("vi-VN")} đ
                                                        </TableCell>
                                                        
                                                        <TableCell sx={{ py: 2 }}>
                                                            {item?.status_payment === "Pending" && <Chip label="Đang chờ" size="small" sx={{ backgroundColor: '#FEF3C7', color: '#F59E0B', fontWeight: 700, borderRadius: '4px' }} />}
                                                            {item?.status_payment === "Success" && <Chip label="Thành công" size="small" sx={{ backgroundColor: '#DCFCE7', color: '#16A34A', fontWeight: 700, borderRadius: '4px' }} />}
                                                            {item?.status_payment === "Deny" && <Chip label="Từ chối" size="small" sx={{ backgroundColor: '#FEE2E2', color: '#EF4444', fontWeight: 700, borderRadius: '4px' }} />}
                                                        </TableCell>

                                                        <TableCell sx={{ py: 2, color: "text.secondary", fontSize: "0.8rem", fontWeight: "600", whiteSpace: "nowrap" }}>
                                                            {formatDate(item?.createdAt)}
                                                        </TableCell>
                                                        
                                                        <TableCell align="right" sx={{ pr: 3, py: 2 }}>
                                                                <Box>
                                                                    <input
                                                                        className="custom-input-metronic" type="text" name="note" placeholder="Ghi chú xử lý..."
                                                                        defaultValue={item?.note} disabled={item?.status_payment !== "Pending"}
                                                                        onChange={(e) => setNote(e.target.value)}
                                                                        style={{ ...inputStyle, marginBottom: "8px", height: "36px", fontWeight: "600" }}
                                                                    />
                                                                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                                                                        <Button
                                                                            variant="contained" color="success" size="small"
                                                                            sx={{ textTransform: "none", boxShadow: "none", borderRadius: "6px", fontWeight: "700", flex: 1 }}
                                                                            disabled={item?.status_payment !== "Pending"}
                                                                            onClick={() => {
                                                                                setLoading(true);
                                                                                axios.post(`${process.env.REACT_APP_API_URL}/payment/update`, { id: item?._id, status: "Accept", note: note })
                                                                                    .then(() => { swal(t("success"), "", "success"); fetchWithdrawals(); })
                                                                                    .catch(() => { swal(t("error"), "", "error"); fetchWithdrawals(); });
                                                                            }}
                                                                        >
                                                                            {t("confirm")}
                                                                        </Button>
                                                                        <Button
                                                                            variant="contained" color="error" size="small"
                                                                            sx={{ textTransform: "none", boxShadow: "none", borderRadius: "6px", fontWeight: "700", flex: 1 }}
                                                                            disabled={item?.status_payment !== "Pending"}
                                                                            onClick={() => {
                                                                                setLoading(true);
                                                                                axios.post(`${process.env.REACT_APP_API_URL}/payment/update`, { id: item?._id, status: "Deny", note: note })
                                                                                    .then(() => { swal(t("success"), "", "success"); fetchWithdrawals(); })
                                                                                    .catch(() => { swal(t("error"), "", "error"); fetchWithdrawals(); });
                                                                            }}
                                                                        >
                                                                            {t("deny")}
                                                                        </Button>
                                                                    </Stack>
                                                                </Box>
                                                          
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        ) : (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={8} align="center" sx={{ py: 6, color: '#A1A5B7', fontWeight: '600' }}>Không có dữ liệu rút tiền</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )}
                                    </Table>
                                </TableContainer>

                                <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end", alignItems: "center", borderTop: '1px solid #EFF2F5' }}>
                                    {data != null ? <Pagination color="primary" shape="rounded" page={page} count={totalPages} size="small" onChange={handleChangePage} sx={{ '& .MuiPaginationItem-root': { fontWeight: 600 } }} /> : null}
                                </Box>
                            </Card>
                        </Container>
                    </Box>

                    {/* POPUP: MODAL DỌN DẸP DỮ LIỆU THEO THỜI GIAN */}
                    <Dialog open={openCleanModal} onClose={() => setOpenCleanModal(false)} maxWidth="sm" fullWidth PaperProps={{ style: { borderRadius: '12px', padding: '8px' } }}>
                        <DialogTitle sx={{ fontWeight: 800, color: '#B91C1C', pb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <DeleteIcon /> Dọn Dẹp Dữ Liệu Rút Tiền
                        </DialogTitle>
                        <DialogContent>
                            <Typography variant="body2" sx={{ color: '#7E8299', mb: 3, fontWeight: 500 }}>
                                Hành động này sẽ xóa các lệnh giao dịch rút tiền theo khoảng thời gian để giảm tải cho máy chủ.
                            </Typography>
                            
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="caption" sx={{ fontWeight: 700, color: '#3F4254', mb: 1.5, display: 'block' }}>
                                    Chọn mốc thời gian muốn lọc & xóa:
                                </Typography>
                                <select 
                                    className="custom-input-metronic" 
                                    style={{ ...inputStyle, cursor: 'pointer' }}
                                    value={cleanRangeType}
                                    onChange={(e) => setCleanRangeType(e.target.value)}
                                >
                                    <option value="week">Dọn dữ liệu 7 ngày qua</option>
                                    <option value="month">Dọn dữ liệu 30 ngày qua</option>
                                    <option value="custom">Tùy chỉnh khoảng thời gian (Ngày - Ngày)</option>
                                </select>
                            </Box>

                            {cleanRangeType === 'custom' && (
                                <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#3F4254', mb: 1, display: 'block' }}>Từ ngày</Typography>
                                        <input type="date" className="custom-input-metronic" style={inputStyle} value={cleanStartDate} onChange={(e) => setCleanStartDate(e.target.value)} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#3F4254', mb: 1, display: 'block' }}>Đến ngày</Typography>
                                        <input type="date" className="custom-input-metronic" style={inputStyle} value={cleanEndDate} onChange={(e) => setCleanEndDate(e.target.value)} />
                                    </Box>
                                </Stack>
                            )}
                        </DialogContent>
                        <DialogActions sx={{ px: 3, pb: 2 }}>
                            <Button onClick={() => setOpenCleanModal(false)} sx={{ color: '#7E8299', fontWeight: 700, textTransform: 'none' }}>Hủy bỏ</Button>
                            <Button onClick={handleCleanDataRange} variant="contained" sx={{ fontWeight: 700, textTransform: 'none', borderRadius: '6px', boxShadow: 'none', backgroundColor: '#EF4444', color: '#FFF', '&:hover': { backgroundColor: '#DC2626' } }}>
                                Xác nhận Lọc & Xóa
                            </Button>
                        </DialogActions>
                    </Dialog>

                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default Request;